<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>学习班信息</span>
        </div>
        <div class="form_box__group__item">
          <span class="form_box__group__item__title">学习班名称：</span>
          <span class="form_box__group__item__content">{{studyClassInfo.studyClassName}}</span>
        </div>
        <div class="form_box__group__item">
          <span class="form_box__group__item__title">上课时间：</span>
          <span class="form_box__group__item__content">{{studyClassInfo.cdate}} {{studyClassInfo.durtime}}</span>
        </div>
        <div class="form_box__group__item">
          <span class="form_box__group__item__title">上课地址：</span>
          <span class="form_box__group__item__content">{{studyClassInfo.location}}</span>
        </div>
      <p class="classTitle">课程信息</p>
      <div v-for="item in studyClassInfo.courses" :key="item.id" class="oneItem">
        <div class="form_box__group__item">
          <span class="form_box__group__item__title">课程名称：</span>
          <span class="form_box__group__item__content">{{item.title}}</span>
        </div>
        <div class="form_box__group__item">
          <span class="form_box__group__item__title">授课讲师：</span>
          <span class="form_box__group__item__content">{{item.teacher}}</span>
        </div>
        <div class="form_box__group__item">
          <span class="form_box__group__item__title">开课时间：</span>
          <span class="form_box__group__item__content">{{item.cdate}} {{item.durtime}}</span>
        </div>
        <div class="form_box__group__item">
          <span class="form_box__group__item__title">课程描述:</span>
          <div v-html="item.description"></div>
        </div>
      </div>
    </el-card>
    <el-card class="box-card">
        <FillCheckUnSignUp :sid="id" :showlevel="studyClassInfo.showlevel"></FillCheckUnSignUp>
    </el-card>

    <el-card class="box-card">
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
          <el-tab-pane label="可补签学员" name="first">
            <el-table :data="tableData" style="width: 100%">
                  <el-table-column
                      type="index"
                      width="50">
                    </el-table-column>
                  <el-table-column label="姓名" prop="name"></el-table-column>
                  <!-- TODO 报名时间、补签时间 -->
                  <el-table-column label="报名时间" prop="date"></el-table-column>
                  <el-table-column label="状态" prop="statusStr"></el-table-column>
                  <el-table-column align="left">
                    <template slot="header">补签</template>
                    <template slot-scope="scope">
                      <el-button size="mini" type="primary" @click="clickBuqian(scope.$index, scope.row)">补签</el-button>
                    </template>
                  </el-table-column>
                </el-table>
          </el-tab-pane>
      </el-tabs>
    </el-card>

    

    
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { detailApi, buqianApi } from "@/api/module/fillcheck/fillcheck";
import { FillCheckUnSignUp } from "@/views/module/fillcheck/comp";

export default {
  name: "FillCheckDetail",
  
  mixins: [BaseVue],
  
  components: {
    FillCheckUnSignUp
  },
  
  data() {
    return {
      id: "",
      tableData: [],
      studyClassInfo: {},
      activeName: "first"
    };
  },
  
  methods: {
    init() {
      detailApi(this.id)
        .then((r) => {
          this.tableData = r.datas;
          this.studyClassInfo = r.scheduling;
          console.log("detail api", r);
        })
        .catch((e) => {
          // 错误处理
        });
    },
    
    clickBuqian(index, row) {
      let data = {
        id: row.id,
      };
      buqianApi(data)
        .then((res) => {
          this.$message({
            message: "补签成功！",
            type: "success",
            duration: 1000,
          });
          setTimeout(() => {
            this.$router.go(0);
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    
    handleTabClick() {
      // 处理标签页点击
    }
  },
  
  mounted() {
    this.id = this.$route.query.id;
    this.init();
  }
};
</script>

<style scoped lang="scss">
.box-card {
  margin-bottom: 20px;
  .top_info {
    div {
      font-size: 14px;
      margin-right: 30px;
      margin-bottom: 18px;
    }
  }
  .classTitle {
    font-size: 16px;
    color: #303133;
    font-weight: 600;
    padding-top: 20px;
    border-top: 1px dotted #ddd;
  }
  .oneItem{
    border-top: 1px dotted #ddd;
    padding-top: 15px;
    &>div{
      margin-bottom: 18px;
    }
  }
  .title {
    color: #303133;
    font-weight: 500;
    display: inline-block;
    font-size: 14px;
    width: 105px;
  }
  .cont {
    color: #3e3e3e;
    font-size: 14px;
  }
}
.clearfix {
  font-size: 16px;
  color: #303133;
  font-weight: 600;
}
</style>